class FaqSection extends HTMLElement {
  constructor() {
    super()

    const faqSectionTemplate = document.createElement('template')
    faqSectionTemplate.innerHTML = `
      <style>
        :host {
          display: block;
          margin: 20px 0;
        }
        h2 {
          font-size: 30px;
          margin-bottom: 10px;
        }
        slot {
          display: block;
        }
      </style>
      
      <div><h2 id="title"></h2>
        <slot></slot>
      </div>
    `

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(faqSectionTemplate.content.cloneNode(true))

    console.log('FaqSection constructor', shadow?.getElementById('title'))
  }

  connectedCallback() {
    const titleText = this.getAttribute('title') || ''
    const title = this.shadowRoot?.getElementById('title')
    console.log('connectedCallback', titleText, title)
    if (title) {
      title.innerHTML = titleText
    }
  }
}

if (!customElements.get('ts-faq-section')) {
  customElements.define('ts-faq-section', FaqSection)
}
export { FaqSection }
